// BDSJEA-406: copiar texto al portapapeles con fallback.
//
// `navigator.clipboard` solo existe en contextos seguros (HTTPS o localhost):
// en un ambiente servido por HTTP plano es `undefined`. En ese caso (o si
// `writeText` rechaza por permisos) se usa un <textarea> temporal con
// `document.execCommand("copy")`.

function copiarConTextarea(texto) {
  const area = document.createElement("textarea")
  area.value = texto
  area.setAttribute("readonly", "")
  area.style.position = "fixed"
  area.style.top = "0"
  area.style.left = "-9999px"
  area.style.opacity = "0"
  document.body.appendChild(area)
  try {
    area.select()
    area.setSelectionRange(0, texto.length)
    return typeof document.execCommand === "function"
      ? document.execCommand("copy") === true
      : false
  } catch {
    return false
  } finally {
    document.body.removeChild(area)
  }
}

/**
 * Copia `texto` al portapapeles. Resuelve `true` si se copio y `false` si
 * ningun metodo funciono (nunca rechaza).
 *
 * @param {string} texto
 * @returns {Promise<boolean>}
 */
export async function copiarAlPortapapeles(texto) {
  const valor = String(texto ?? "")
  if (!valor) return false
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(valor)
      return true
    } catch {
      // Permiso denegado o documento sin foco: se intenta el fallback.
    }
  }
  return copiarConTextarea(valor)
}

/** Deja solo los digitos de un CUIT ("20-12345678-9" -> "20123456789"). */
export const cuitSinGuiones = valor => String(valor ?? "").replace(/\D/g, "")
